var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36363 5.44226C4.22015 5.4044 4.1009 5.30477 4.03812 5.17032C3.97535 5.03586 3.97554 4.88046 4.03865 4.74616L5.14581 2.3899C5.22832 2.21431 5.40496 2.1023 5.59896 2.10254C5.79297 2.10278 5.96933 2.21523 6.0514 2.39102L6.53982 3.43718C6.55728 3.43032 6.57531 3.42436 6.59387 3.41939C9.4921 2.64281 12.4711 4.36275 13.2477 7.26099C14.0243 10.1592 12.3043 13.1382 9.40611 13.9148C6.50787 14.6914 3.52885 12.9715 2.75227 10.0732C2.50532 9.1516 2.51088 8.22035 2.72717 7.35452C2.79409 7.08661 3.06553 6.92368 3.33344 6.99061C3.60135 7.05754 3.76428 7.32897 3.69736 7.59688C3.52116 8.30221 3.5163 9.06092 3.7182 9.81441C4.35184 12.1792 6.78252 13.5825 9.14729 12.9489C11.5121 12.3153 12.9154 9.88457 12.2818 7.51981C11.6585 5.1937 9.29646 3.79783 6.96873 4.35587L7.46152 5.4114C7.54359 5.58719 7.51656 5.7946 7.39218 5.94348C7.26779 6.09237 7.06851 6.15587 6.88092 6.10638L4.36363 5.44226Z",
    fill: "#0E46C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.37aa9d48ac60c643dccc2a9e33d0c096.svg";
export { ForwardRef as ReactComponent };